<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { RepositoryFactory } from '@/data/repositoryFactory.js';
import { isNotEmptyArray } from '../../../helpers/utilsHelper';
import DebugPanel from '../../test/DebugPanel.vue';

const props = defineProps({ addresses: Array, isLoading: Boolean });
const emit = defineEmits(['update:addresses']);

const RepositoryDictionaries = RepositoryFactory.get('dictionaries');
const orderRanges = ref(null);

const isLoadingForm = computed(() => {
  return !Array.isArray(orderRanges.value);
});

watch(
  () => props.addresses,
  (newValue) => {
    emit('update:addresses', newValue);
  },
  { deep: true }
);

async function fetchOrderRanges() {
  RepositoryDictionaries.getDictionaryElementsObject(1, 100, '', '', '', 'orderrange')
    .then((data) => {
      orderRanges.value = data?.data ?? [];
      if (isNotEmptyArray(orderRanges.value)) {
        orderRanges.value = orderRanges.value.map((range) => {
          return {
            id: range.id,
            name: range.name
          };
        });
      }
    })
    .catch((error) => console.log(error))
    .finally(() => {});
}

onMounted(() => {
  fetchOrderRanges();
});
</script>

<template>
  <div class="ibox mt-4">
    <div class="ibox-title">
      <h5>Adresy</h5>
    </div>

    <div class="ibox-content" :class="{ 'sk-loading': props.isLoading || isLoadingForm }">
      <div class="sk-spinner sk-spinner-three-bounce">
        <div class="sk-bounce1"></div>
        <div class="sk-bounce2"></div>
        <div class="sk-bounce3"></div>
      </div>

      <div v-if="isNotEmptyArray(props.addresses)" class="table-responsive mb-3 ml-auto mr-auto">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Zakres</th>
              <th>Adres</th>
              <th style="width: 90px">Ilość</th>
              <th>Uwagi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in props.addresses" :key="row.id">
              <td>
                <select class="form-control" v-model="row.range_object" required>
                  <option
                    v-for="orderRange in orderRanges"
                    :key="orderRange.id"
                    :value="orderRange"
                  >
                    {{ orderRange.name }}
                  </option>
                </select>

                <div v-if="row.range_object == null" class="text-danger">
                  Niepoprawny zakres: "{{ row.range }}"
                </div>
              </td>

              <td>
                <textarea
                  placeholder="Wpisz adres"
                  v-model="row.address"
                  class="form-control"
                  maxlength="500"
                  required
                ></textarea>
              </td>

              <td style="width: 90px">
                <input
                  type="number"
                  placeholder="Wpisz ilość"
                  v-model="row.quantity"
                  class="form-control"
                  min="0"
                  max="999999999"
                  required
                />
              </td>

              <td>
                <textarea
                  placeholder="Wpisz uwagi"
                  v-model="row.note"
                  class="form-control"
                  maxlength="500"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else>
        <p class="text-center mt-3 mb-3">Brak elementów do wyświetlenia</p>
      </div>
    </div>
  </div>

  <DebugPanel>
    <pre>{{ orderRanges }}</pre>
  </DebugPanel>
</template>

<style scoped>
td {
  vertical-align: middle !important;
}

.table-responsive td:nth-child(1),
.table-responsive th:nth-child(1) {
  min-width: 550px;
}

.table-responsive td:nth-child(2),
.table-responsive th:nth-child(2) {
  min-width: 300px;
}

.table-responsive td:nth-child(3),
.table-responsive th:nth-child(3) {
  min-width: 100px;
}

.table-responsive td:nth-child(4),
.table-responsive th:nth-child(4) {
  min-width: 250px;
}
</style>
